import React from "react";
import styled from "@emotion/styled";
import { mediaQueriesMax } from "@src/styles/theme";
import { Box } from "@src/components/Boxes";
import LessonHero from "@src/components/ideas/LessonHero";
import LessonMetaTop from "@src/components/ideas/LessonMetaTop";
import LessonMetaBottom from "@src/components/ideas/LessonMetaBottom";
import DiscussionGuideLink from "@src/components/ideas/DiscussionGuideLink";

const Cover = styled("div")`
  * > &:last-of-type {
    margin-bottom: 0;
  }

  &.is-naked {
    padding: 0;
  }

  ${mediaQueriesMax.lesson} {
    padding: 0 0 108px 0;
  }

  padding: 0 0 52px 0;
  margin: 0;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
  border: solid 1px rgba(0, 0, 0, 0.12);

  ${mediaQueriesMax.lesson} {
    padding: 0 0 108px 0;
  }
`;
const LessonCover = (props) => {
  let activityDuration = props.lesson.duration ? props.lesson.duration.trim() : "";

  activityDuration =
    activityDuration[activityDuration.length - 1] === "s" ? activityDuration.slice(0, -1) : activityDuration;

  return (
    <Cover>
      <Box position="relative">
        <LessonHero
          {...props.lesson}
          slug={props.lesson.slug}
          requireAuth={props.lesson.require_auth}
          user={props.user}
          youTubeEnabled={props.youTubeEnabled}
          showButton={props.showButton}
        />
        <LessonMetaTop title={props.meta.title} duration={activityDuration} author={props.lesson.publisher.name} />
        <LessonMetaBottom
          {...props.meta}
          steps={props.lesson.slides}
          slug={props.lesson.slug}
          user={props.user}
          requireAuth={props.lesson.require_auth}
        />
        {props.discussionGuideLink && <DiscussionGuideLink link={props.discussionGuideLink} />}
      </Box>
    </Cover>
  );
};

export default LessonCover;
